export default __webpack_public_path__ + "static/media/favorite_24dp.53c45348.svg";